import { PERSONAL_CODE_LENGTH } from "common/constants";
import { EMAIL_REGEX_EXPRESSION, INVALID_EMAIL_DOMAIN_REGEX_EXPRESSION } from "common/constants/regex";
import { IElectricityAgreement, MeteringPoint } from "components/ElectricityAgreements/models";

export const isValidEmail = (email: string) => {
  if(INVALID_EMAIL_DOMAIN_REGEX_EXPRESSION.test(email)) return false;

  return EMAIL_REGEX_EXPRESSION.test(email);
}

export const isEmailValidAndPresent = (email?: string) => {
  if(!email) return false;
  return isValidEmail(email.trim());
}

export const isValidCommaSeparatedEmail = (email: string) => {
  return email.split(",").every(email => isValidEmail(email.trim()));
}

export const validateCommaSeparatedPersonalIdentificationCodes = (personalCodes?: string[]) => {
  if(!personalCodes?.length) return true;
  if(personalCodes.every(val => !!val.trim() && val.trim().length === PERSONAL_CODE_LENGTH)) return true;
  return false;
}

export const isJointInvoicePossible = (isCompany: boolean, meteringPoints: MeteringPoint[]) => {
  return !isCompany && meteringPoints.some(mp => mp.hasMatchingGridOperator)
}

export const isJointInvoicePossibleForAgreement = (agreement: IElectricityAgreement) => {
  return isJointInvoicePossible(agreement.customer.isCompany, agreement.meteringPoints);
}